import {
  UrlAudioPlayer,
  TUrlAudioPlayerProps,
} from './url-audio-player';

export { UrlAudioPlayer, type TUrlAudioPlayerProps };
